import React, { useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    subject: '',
    message: '',
  });

  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Submitting...');

    try {
      const response = await fetch('http://localhost:5000/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      if (result.success) {
        setStatus('Form submitted successfully!');
        setFormData({ firstName: '', lastName: '', email: '', subject: '', message: '' });
      } else {
        setStatus('Failed to submit form.');
      }
      } catch (error) {
        console.error('Error submitting form:', error);
        setStatus('An error occurred. Please try again.');
      }
  };

  // ... (your styles can remain unchanged)
  const inputStyle = {
    width: '100%',
    padding: '12px 16px',
    fontSize: '1rem',
    borderRadius: '4px',
    border: '1px solid #ccc',
    marginBottom: '20px',
  };

  const buttonStyle = {
    backgroundColor: '#c0a875',
    color: '#fff',
    border: 'none',
    padding: '14px 32px',
    fontSize: '1rem',
    cursor: 'pointer',
    borderRadius: '2px',
    letterSpacing: '2px',
  };

  return (
    <>
      <Navbar />
      <div style={{ padding: '50px 100px', display: 'flex', justifyContent: 'space-between', background: '#e8f0ee', fontFamily: 'Courier New, monospace' }}>
        <div style={{ width: '40%', color: '#5a2a18', fontSize: '1.2rem', lineHeight: '1.8' }}>
          <p style={{ fontWeight: 'bold', fontSize: '20px' }}>Feel free to contact us for any questions and doubts</p>
          <p style={{ fontWeight: 'bold', fontSize: '20px' }}>Bharat Araku Coffee</p>
          <p>Shivajinagar, Pune, Maharashtra.<br />India, 411 004</p>
          <p style={{ fontWeight: 'bold', fontSize: '20px' }}>Ph:</p>
          <p>+91 90112 11111</p>
          <p style={{ fontWeight: 'bold', fontSize: '20px' }}>Email:</p>
          <p>connect@magicroastqoffee.com</p>
        </div>
        <div style={{ width: '50%', backgroundColor: '#fff', padding: '40px', borderRadius: '10px', boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)' }}>
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'flex', gap: '20px' }}>
              <input name="firstName" type="text" placeholder="First Name" value={formData.firstName} onChange={handleChange} style={{ ...inputStyle, width: '50%' }} required />
              <input name="lastName" type="text" placeholder="Last Name" value={formData.lastName} onChange={handleChange} style={{ ...inputStyle, width: '50%' }} required />
            </div>
            <input name="email" type="email" placeholder="Email Address" value={formData.email} onChange={handleChange} style={inputStyle} required />
            <input name="subject" type="text" placeholder="Subject" value={formData.subject} onChange={handleChange} style={inputStyle} required />
            <textarea name="message" placeholder="Your Message" rows="4" value={formData.message} onChange={handleChange} style={{ ...inputStyle, resize: 'none' }} required></textarea>
            <button type="submit" style={buttonStyle}>SUBMIT FORM</button>
            <p style={{ marginTop: '10px', color: 'green' }}>{status}</p>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactForm;
